import { SVGProps } from '@components/Icon/types';

export const Send = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.5, 3.5)">
      <path
        d="M0.171122 5.77796C0.101158 5.85319 0.0503587 5.94418 0.0230296 6.04321C-0.00429949 6.14225 -0.00735354 6.24641 0.0141261 6.34688C0.0356057 6.44735 0.0809861 6.54116 0.146422 6.62036C0.211859 6.69956 0.295423 6.76183 0.390035 6.80188L7.98489 10.0149L11.198 17.6096C11.2485 17.7292 11.3343 17.8306 11.444 17.9003C11.5536 17.97 11.6818 18.0046 11.8116 17.9995C11.9414 17.9945 12.0666 17.95 12.1705 17.872C12.2744 17.7941 12.3521 17.6863 12.3932 17.5631L17.9672 0.841354C18.0047 0.728736 18.0102 0.607889 17.9829 0.492353C17.9556 0.376817 17.8967 0.271159 17.8128 0.187217C17.7288 0.103276 17.6232 0.0443692 17.5076 0.0170969C17.3921 -0.0101753 17.2712 -0.00473498 17.1586 0.0328084L0.436524 5.60671C0.335125 5.64069 0.243872 5.69957 0.171122 5.77796ZM2.44734 6.28403L16.3507 1.64931L11.7158 15.5523L9.22952 9.67416L13.2935 5.61024C13.3543 5.5512 13.4027 5.48068 13.4359 5.40277C13.4691 5.32487 13.4866 5.24113 13.4872 5.15643C13.4878 5.07173 13.4715 4.98776 13.4394 4.90939C13.4072 4.83102 13.3599 4.75982 13.3 4.69993C13.2401 4.64004 13.1689 4.59264 13.0905 4.56051C13.0121 4.52837 12.9281 4.51213 12.8434 4.51273C12.7587 4.51333 12.675 4.53076 12.5971 4.564C12.5192 4.59724 12.4487 4.64563 12.3896 4.70637L8.32562 8.77028L2.44734 6.28403Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'send';
